export default __webpack_public_path__ + "static/media/7200c6dd8ac604abe09f5159e53a40c0.4c83eaef.svg";